import React from 'react';

export default () => <svg width="24.25mm" height="24.25mm"
    viewBox="0 0 2425 2425" >
    <g id="Слой_x0020_1">
        <polygon class="ui_icon__fill" points="1026,1439 276,1439 276,2047 1026,2047 1026,1779 1218,1779 1218,1249 1378,1249 1378,1516 2128,1516 2128,909 1378,909 1378,1177 1218,1177 1218,646 1026,646 1026,378 276,378 276,986 1026,986 1026,718 1179,718 1179,1707 1026,1707 " />
    </g>
</svg>